export const LIST_HOLIDAY = 'LIST_HOLIDAY';
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY';
export const ADD_HOLIDAY = 'ADD_HOLIDAY';
